import React from 'react';

const Icon = ({ size = '44', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 44 44" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="2.017" strokeLinecap="round" strokeLinejoin="round">
                <path d="M35.206 7.217H9.663a2.017 2.017 0 0 0-2.017 2.016v24.2c0 1.113.903 2.016 2.017 2.016h25.543a2.017 2.017 0 0 0 2.017-2.016v-24.2a2.017 2.017 0 0 0-2.017-2.016Z" />

                <path d="M17.057 11.25H7.646v5.378h7.394a2.017 2.017 0 0 0 2.017-2.017V11.25Zm0 24.2h-5.378v1.344h5.378v-1.345Zm16.133 0h-5.378v1.344h5.378v-1.345ZM7.646 11.25h29.577" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M.924.494h43.021v43.021H.924z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
